import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCRypaOI7oRF4jDyi5XM-6lWGQ0b7fo9Q8",
  authDomain: "gig-fort-terms.firebaseapp.com",
  projectId: "gig-fort-terms",
  storageBucket: "gig-fort-terms.firebasestorage.app",
  messagingSenderId: "118173468451",
  appId: "1:118173468451:web:4394e58ad169064befee96"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);